var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderFailed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35,
    stroke: "#FF6363",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6654 36.0007C52.6654 45.2054 45.2034 52.6673 35.9987 52.6673C26.794 52.6673 19.332 45.2054 19.332 36.0007C19.332 26.7959 26.794 19.334 35.9987 19.334C45.2034 19.334 52.6654 26.7959 52.6654 36.0007Z",
    fill: "#FF6363"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9481 30.9501C31.4363 30.4619 32.2278 30.4619 32.7159 30.9501L35.9987 34.2329L39.2815 30.9501C39.7696 30.462 40.5611 30.462 41.0492 30.9501C41.5374 31.4383 41.5374 32.2297 41.0492 32.7179L37.7665 36.0007L41.0492 39.2834C41.5374 39.7716 41.5374 40.563 41.0492 41.0512C40.5611 41.5393 39.7696 41.5393 39.2814 41.0512L35.9987 37.7684L32.716 41.0512C32.2278 41.5394 31.4363 41.5394 30.9482 41.0512C30.46 40.563 30.46 39.7716 30.9482 39.2834L34.2309 36.0007L30.9481 32.7179C30.46 32.2297 30.46 31.4383 30.9481 30.9501Z",
    fill: "#FFA0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderFailed);
export default __webpack_public_path__ + "static/media/order-failed.c46576fd6550329df0e51f28acf075d7.svg";
export { ForwardRef as ReactComponent };